<script lang="ts">
  import { splitIo } from '@stores'

  import SilentLogin from './OidcContext/SilentLogin.svelte'
  import SupportWidgetProfile from './SupportWidgetProfile.svelte'
  import ErrorHandler from './ErrorHandler.svelte'
  import { SetOmniApolloCredentialsFromOidcContext } from './'
  import AuthenticationContext, { isAuthenticated } from './AuthenticationContext.svelte'
  import Notifications from './Notifications.svelte'

  console.log('Starting HDC Support Widget')
  // element properties
  export let memberid = ''
  export let accountid = ''
  export let email = ''

  function refreshWidget() {
    location.reload()
  }
</script>

<style>
  .refresh-widget {
    background-color: white;
    border: none;
    border-bottom: 1px solid #8e949a;
    cursor: pointer;
    font-size: 12px;
    line-height: 22px;
    float: right;
    margin: 0;
    margin-right: 16px;
    padding: 0;
    color: #8e949a;
  }
</style>

{#if $splitIo.ready}
  <div class="hdc-support-widget">
    <AuthenticationContext>
      <button class="refresh-widget" data-test="refresh-login" on:click={refreshWidget}>Refresh</button>
      <SilentLogin />
      {#if $isAuthenticated}
        <SetOmniApolloCredentialsFromOidcContext>
          <SupportWidgetProfile {memberid} {accountid} {email} />
        </SetOmniApolloCredentialsFromOidcContext>
      {/if}
    </AuthenticationContext>
    <ErrorHandler />
    <Notifications />
  </div>

{:else}
  <span>Loading Split...</span>
{/if}
